import type { PaginatedDeployment } from "@/api/resources/deployments/types";
import type { PaginatedDeviceTag, PaginatedDeviceTagLeveled } from "@/api/resources/deviceTags/types";
import { getDeviceTagsLeveled, getDeviceTagsLeveledFlattened } from "@/api/resources/deviceTags/utils";
import type { FilterOptions } from "@/providers/globalFiltersConfig";
import { filterNotEmpty } from "@/utils/format";

interface SelectorCurrentDeviceTagsProps {
  currentWorkspaceId?: string;
  deviceTags: PaginatedDeviceTag[];
}
export const selectorCurrentDeviceTags = ({ currentWorkspaceId, deviceTags }: SelectorCurrentDeviceTagsProps) => {
  return deviceTags.filter((deviceTag) => deviceTag.workspace_id === currentWorkspaceId);
};

interface SelectorFilteredDeviceTagsProps {
  deviceTags: PaginatedDeviceTag[];
  filteredDeployments: PaginatedDeployment[];
  options: FilterOptions;
}
export const selectorFilteredDeviceTags = ({
  deviceTags,
  filteredDeployments,
  options,
}: SelectorFilteredDeviceTagsProps) => {
  const filteredDeploymentsWorkspaceIds = filteredDeployments.map((d) => d.workspace_id);
  let _deviceTags = deviceTags.filter((_deviceTag) => {
    return filteredDeploymentsWorkspaceIds.includes(_deviceTag.workspace_id);
  });

  if (options.deployments.length > 0) {
    const _deploymentsWorkspaceIds = options.deployments
      .map((deployment_id) => filteredDeployments.find((deployment) => deployment.id === deployment_id)?.workspace_id)
      .filter(filterNotEmpty);
    _deviceTags = _deviceTags.filter(({ workspace_id }) => {
      if (!workspace_id) return true;
      return _deploymentsWorkspaceIds.includes(workspace_id);
    });
  }

  return _deviceTags;
};

export const selectorDeviceTagsLeveled = (deviceTags: PaginatedDeviceTag[]) => {
  return getDeviceTagsLeveled(deviceTags);
};

export const selectorDeviceTagsLeveledFlattened = (deviceTagsLeveled: PaginatedDeviceTagLeveled[]) => {
  return getDeviceTagsLeveledFlattened(deviceTagsLeveled);
};
